class StringHelper {
    public capitalize(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1).toLocaleLowerCase();
    }
}

export default new StringHelper();